// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRocketOutlinedSvg from "@fishx/icons-svg/es/asn/PRocketOutlined";
import FishxIcon from '../components/FishxIcon';

var PRocketOutlined = function PRocketOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRocketOutlinedSvg
  }));
};

PRocketOutlined.displayName = 'PRocketOutlined';
export default React.forwardRef(PRocketOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRocketOutlined.js
// module id = 3606
// module chunks = 0